import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'
import CommonModal from '@/components-latest/shared/Modals/CommonModal'

import Styles from './HowItWorksModal.module.scss'

interface IHowItWorksModalProps {
  children: React.ReactNode
  type?: string
}

const HowItWorksModal: React.FC<IHowItWorksModalProps> = ({
  children,
  type
}) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(false)

  const body = useMemo(
    () =>
      type?.toLowerCase() === 'france' ? (
        <div className={Styles.description}>
          <Text variant="nextSubtitle" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="bold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.vat.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.vat.description')}
          </Text>

          <Text variant="nextSubtitle" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="bold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.due-to-receive.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.due-to-receive.description')}
          </Text>

          <Text variant="nextBody" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.gross-earning.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.gross-earning.description')}
          </Text>

          <Text variant="nextBody" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.yassir-commission.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.yassir-commission.description')}
          </Text>

          <Text variant="nextBody" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.vat-definition.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.vat-definition.description')}
          </Text>

          <Text variant="nextBody">
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>
                {t('billing.how-it-works.due-to-receive-definition.label')}
              </span>
            </Text>{' '}
            {t('billing.how-it-works.due-to-receive-definition.description')}
          </Text>
        </div>
      ) : (
        <div className={Styles.description}>
          <Text variant="nextSubtitle" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="bold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.net-profit.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.net-profit.description')}
          </Text>

          <Text variant="nextBody" gutter={16}>
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.gross-earning.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.gross-earning.description')}
          </Text>

          <Text variant="nextBody">
            <Text
              asChild
              variant="nextSubtitle"
              weight="semiBold"
              className={Styles.highlighted}>
              <span>{t('billing.how-it-works.yassir-commission.label')}</span>
            </Text>{' '}
            {t('billing.how-it-works.yassir-commission.description')}
          </Text>
        </div>
      ),
    [t, type]
  )

  return (
    <CommonModal
      scrollableBody
      className={Styles.modal}
      body={body}
      open={isOpen}
      title={
        <Text variant="nextTitle-2" align="center">
          {t('billing.how-it-works.title')}
        </Text>
      }
      onOpenChange={open => setIsOpen(open)}>
      {children}
    </CommonModal>
  )
}

export default HowItWorksModal
